import React from "react";
import { connect } from "react-redux";
import LoginForgetPass from "./Login_Forget_Pass";
import LoginGetOTP from "./Login_Get_OTP";
import LoginResetPassword from "./LoginResetPassword";
import { useHistory } from "react-router-dom";
import Store from "../../redux/Store";
import { getRecoverCode } from "../../redux/Login/LoginActionCreators";

const LoginRecoverPassword = ({ Login_Recover_Page }) => {
  const history = useHistory();
  React.useEffect(() => {
    Store.dispatch(getRecoverCode(1));
  }, []);

  return (
    <>
      {Login_Recover_Page === 1 ? (
        <LoginForgetPass />
      ) : Login_Recover_Page === 2 ? (
        <LoginGetOTP />
      ) : Login_Recover_Page === 3 ? (
        <LoginResetPassword />
      ) : (
        history.push("/")
      )}
    </>
  );
};
const mapStateToProps = (props) => {
  const { loginReducer } = props;
  const { Login_Recover_Page } = loginReducer;

  return { Login_Recover_Page };
};
export default connect(mapStateToProps)(LoginRecoverPassword);
